<div class="loader-container">
    <app-loader *ngIf="loading == true"></app-loader>
    <app-modal-header *ngIf="modalStyle === true" [title]="modalTitle"></app-modal-header>
    <div [ngClass]="{
        'modal-body': modalStyle === true
    }">
        <div *ngIf="errorMessage && errorMessage.length" class="alert alert-danger d-flex align-items-center"
            role="alert">
            <div>
                {{errorMessage}}
            </div>
        </div>

        <app-tab-group>
            <app-tab tabTitle="Algemeen">
                <div class="container-fluid">
                    <div class="row mb-3" *ngIf="!item['id']">
                        <div class="col-12">
                            <label class="form-label">Type</label>
                            <div class="d-flex">
                                <div class="form-check me-5">
                                    <input class="form-check-input" id="type_h2m" type="radio" name="type"
                                        [(ngModel)]="item['type']" [value]="'H2M'">
                                    <label class="form-check-label" for="type_h2m">H2M <small>Human 2
                                            Machine</small></label>
                                </div>
                                <div class="form-check">
                                    <input class="form-check-input" id="type_m2m" type="radio" name="type"
                                        [(ngModel)]="item['type']" [value]="'M2M'">
                                    <label class="form-check-label" for="type_m2m">M2M <small>Machine 2
                                            Machine</small></label>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="row mb-3" *ngIf="item['id']">
                        <div class="col-12">
                            <label class="form-label">Type</label>
                            <div class="d-flex">
                                {{item['type']}}
                            </div>
                        </div>
                    </div>

                    <div class="row mb-3" *ngIf="item['id'] && item['type'] == 'H2M'">
                        <div class="col-12">
                            <label class="form-label">Client</label>
                            <div class="d-flex">
                                <input style="background:#EEEEEE;" type="text" [(ngModel)]="item['id']"
                                    class="form-control">
                            </div>
                        </div>
                    </div>

                    <div class="row mb-3" *ngIf="item['id'] && item['type'] == 'M2M'">
                        <div class="col-6">
                            <label class="form-label">Client</label>
                            <div class="d-flex">
                                <input style="background:#EEEEEE;" type="text" [(ngModel)]="item['id']"
                                    class="form-control">
                            </div>
                        </div>
                        <div class="col-6">
                            <label class="form-label">Secret</label>
                            <div class="d-flex">
                                <input style="background:#EEEEEE;" type="text" [(ngModel)]="item['secret']"
                                    class="form-control">
                            </div>
                        </div>
                    </div>

                    <div class="row mb-3" *ngIf="item['type']">
                        <div class="col-12">
                            <label class="form-label">Naam</label>
                            <input [ngClass]="{'is-invalid': errors['name']}" type="text" [(ngModel)]="item['name']"
                                class="form-control" placeholder="">
                        </div>
                    </div>

                    <div class="row mb-3" *ngIf="item['type']">
                        <div class="col-12">
                            <label class="form-label">Service provider</label>
                            <select [ngClass]="{'is-invalid': errors['service_provider']}" class="form-control"
                                [(ngModel)]="item['service_provider']" name="service_provider">
                                <option value=""></option>
                                <option *ngFor="let serviceProvider of serviceProviderOptions" [value]="serviceProvider">
                                    {{serviceProvider}}
                                </option>
                            </select>
                        </div>
                    </div>

                    <div class="row mb-3" *ngIf="item['type']">
                        <div class="col-12">
                            <label class="form-label">Geblokkeerd</label>
                            <div class="d-flex">
                                <div class="form-check me-5">
                                    <input class="form-check-input" id="revoked_no" type="radio" name="revoked"
                                        [(ngModel)]="item['revoked']" [value]="1">
                                    <label class="form-check-label" for="revoked_no">Ja</label>
                                </div>
                                <div class="form-check">
                                    <input class="form-check-input" id="revoked_yes" type="radio" name="revoked"
                                        [(ngModel)]="item['revoked']" [value]="0">
                                    <label class="form-check-label" for="revoked_yes">Nee</label>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="row mb-3" *ngIf="item['type'] && item['type'] == 'H2M'">
                        <div class="col-12">
                            <label class="form-label">Redirect URL</label>
                            <input [ngClass]="{'is-invalid': errors['redirect']}" type="text"
                                [(ngModel)]="item['redirect']" class="form-control" placeholder="">
                        </div>
                    </div>

                    <div class="row mb-3" *ngIf="item['type'] && item['type'] == 'M2M'">
                        <div class="col-6">
                            <label class="form-label">PKIO vereist</label>
                            <div class="d-flex">
                                <div class="form-check me-5">
                                    <input class="form-check-input" id="pkioRequired_1" type="radio"
                                        name="pkio_required" [(ngModel)]="item['pkio_required']" [value]="1">
                                    <label class="form-check-label" for="pkioRequired_1">Ja</label>
                                </div>
                                <div class="form-check">
                                    <input class="form-check-input" id="pkioRequired_0" type="radio"
                                        name="pkio_required" [(ngModel)]="item['pkio_required']" [value]="0">
                                    <label class="form-check-label" for="pkioRequired_0">Nee</label>
                                </div>
                            </div>
                        </div>
                        <div class="col-6">
                            <label class="form-label">Is EDU-V</label>
                            <div class="d-flex">
                                <div class="form-check me-5">
                                    <input class="form-check-input" id="isEduv_1" type="radio" name="is_eduv"
                                        [(ngModel)]="item['is_eduv']" [value]="1">
                                    <label class="form-check-label" for="isEduv_1">Ja</label>
                                </div>
                                <div class="form-check">
                                    <input class="form-check-input" id="isEduv_0" type="radio" name="is_eduv"
                                        [(ngModel)]="item['is_eduv']" [value]="0">
                                    <label class="form-check-label" for="isEduv_0">Nee</label>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="row mb-3" *ngIf="item['type'] && item['type'] == 'M2M' && item['pkio_required'] === 1">
                        <div class="col-6">
                            <label class="form-label">OIN <small>Organisatie-identificatienummer</small></label>
                            <input [ngClass]="{'is-invalid': errors['oin_number']}" type="text"
                                [(ngModel)]="item['oin_number']" class="form-control" placeholder="">
                        </div>
                        <div class="col-6">
                            <label class="form-label">PKIO url</label>
                            <input [ngClass]="{'is-invalid': errors['certificate_url']}" type="text"
                                [(ngModel)]="item['certificate_url']" class="form-control" placeholder="">
                        </div>
                    </div>

                    <div class="row mb-3" *ngIf="item['type'] && item['type'] == 'M2M'">
                        <div class="col-6">
                            <label class="form-label">Uitgaande berichten</label>
                            <div class="d-flex">
                                <div class="form-check me-5">
                                    <input class="form-check-input" id="has_external_1" type="radio" name="has_external"
                                        [(ngModel)]="item['has_external']" [value]="1">
                                    <label class="form-check-label" for="has_external_1">Ja</label>
                                </div>
                                <div class="form-check">
                                    <input class="form-check-input" id="has_external_0" type="radio" name="has_external"
                                        [(ngModel)]="item['has_external']" [value]="0">
                                    <label class="form-check-label" for="has_external_0">Nee</label>
                                </div>
                            </div>
                        </div>
                        <div class="col-6">
                        </div>
                    </div>

                    <div class="row mb-3" *ngIf="item['type'] && item['type'] == 'M2M'">
                        <div class="col-6">
                            <label class="form-label">Consent vereist</label>
                            <div class="d-flex">
                                <div class="form-check me-5">
                                    <input class="form-check-input" id="consent_required_1" type="radio"
                                        name="consent_required" [(ngModel)]="item['consent_required']" [value]="1">
                                    <label class="form-check-label" for="consent_required_1">Ja</label>
                                </div>
                                <div class="form-check">
                                    <input class="form-check-input" id="consent_required_0" type="radio"
                                        name="consent_required" [(ngModel)]="item['consent_required']" [value]="0">
                                    <label class="form-check-label" for="consent_required_0">Nee</label>
                                </div>
                            </div>
                        </div>
                        <div class="col-6">
                            <label class="form-label">Consent type</label>
                            <select name="consent_required_type" [(ngModel)]="item['consent_required_type']" class="form-control">
                                <option value=""></option>
                                <option value="provider">Verzender</option>
                                <option value="consumer">Afnemer</option>
                            </select>
                        </div>
                    </div>

                    <div class="row mb-3" *ngIf="item['type'] && item['type'] == 'M2M' && item['has_external'] === 1">
                        <div class="col-6">
                            <label class="form-label">API url</label>
                            <input [ngClass]="{'is-invalid': errors['external_base_url']}" type="text"
                                [(ngModel)]="item['external_base_url']" class="form-control" placeholder="">
                        </div>
                        <div class="col-6">
                            <label class="form-label">Auth url</label>
                            <input [ngClass]="{'is-invalid': errors['external_auth_url']}" type="text"
                                [(ngModel)]="item['external_auth_url']" class="form-control" placeholder="">
                        </div>
                    </div>

                    <div class="row mb-3" *ngIf="item['type'] && item['type'] == 'M2M' && item['has_external'] === 1">
                        <div class="col-6">
                            <label class="form-label">Client</label>
                            <input [ngClass]="{'is-invalid': errors['external_client']}" type="text"
                                [(ngModel)]="item['external_client']" class="form-control" placeholder="">
                        </div>
                        <div class="col-6">
                            <label class="form-label">Secret</label>
                            <input [ngClass]="{'is-invalid': errors['external_secret']}" type="text"
                                [(ngModel)]="item['external_secret']" class="form-control" placeholder="">
                        </div>
                    </div>

                    <div class="row mb-3" *ngIf="item['type'] && item['type'] == 'M2M' && item['has_external'] === 1">
                        <div class="col-6">
                            <label class="form-label">Common name</label>
                            <input [ngClass]="{'is-invalid': errors['common_name']}" type="text"
                                [(ngModel)]="item['common_name']" class="form-control" placeholder="">
                        </div>
                        <div class="col-6">
                            <label class="form-label">Scopes</label>
                            <input [ngClass]="{'is-invalid': errors['external_scopes']}" type="text"
                                [(ngModel)]="item['external_scopes']" class="form-control" placeholder="">
                        </div>
                    </div>

                    <div class="row mb-3" *ngIf="item['type'] && item['type'] == 'M2M' && item['has_external'] === 1">
                        <div class="col-12" *ngIf="refreshExternalTokenMessage">
                            <div class="alert alert-info px-3 py-2 mb-1 mt-1">
                                {{refreshExternalTokenMessage}}
                            </div>
                        </div>
                        <div class="col-8">
                            <div *ngIf="item['external_token_expired_at']">Token succesvol ontvangen {{item['external_token_expired_at'] | dutchDateTime}}</div>
                            <div *ngIf="!item['external_token_expired_at']">Nog geen token</div>
                        </div>
                        <div class="col-4">
                            <button (click)="refreshExternalToken()" class="btn btn-secondary btn-xs">Token aanvragen</button>
                        </div>
                    </div>


                    
                </div>
            </app-tab>

            <app-tab tabTitle="Scopes">
                <div class="card-body card-table">
                    <div class="scopes-container">
                        <p>Beschikbare scopes</p> 
                        <div class="form-check form-checkbox mb-2" *ngFor="let scope of scopes">
                            <input id="input_{{scope | slugify}}" class="form-check-input"
                                [(ngModel)]="selectedScopes[scope]" type="checkbox"
                                name="input_{{scope | slugify}}">
                            <label 
                                for="input_{{scope | slugify}}" 
                                class="form-check-label">
                                    {{scope}}    
                            </label>
                        </div>
                    </div>
                </div>
            </app-tab>
        </app-tab-group>

        <div class="form-buttons">
            <button type="button" class="btn btn-primary" (click)="save()">
                <span *ngIf="!item['id']">Toevoegen</span>
                <span *ngIf="item['id']">Opslaan</span>
            </button>
        </div>
    </div>
</div>
